import * as yup from 'yup'
import {
  getCardNameSchema,
  getExpiryDate,
  getRequiredSchema,
  getRequiredCheckboxSchema,
} from 'src/deps'
import {
  addPaymentToProfileErrorMsg,
  savePaymentToProfileErrorMsg,
} from 'src/deps/validationErrorMessages'
import {
  tokenExContainer,
  paymetricContainer,
  customerContainer,
} from 'src/models'
import { convertToBoolean } from 'src/utils'
import { APPConfig } from 'config/appConfig'

const getPaymentContainer = () => {
  const enableDirectPaymetricAndAccertifyIntegration = convertToBoolean(
    APPConfig?.getAppConfig()?.enableDirectPaymetricAndAccertifyIntegration
  )
  return enableDirectPaymetricAndAccertifyIntegration
    ? paymetricContainer
    : tokenExContainer
}

export const schema = (props = {}) => {
  const {
    isFromEditPayment = false,
    shouldRenderAddressForm = false,
    isFromCheckout = false,
    isFromEditSubscription = false,
    hasSubscriptionProduct = false,
    isFromPayment,
  } = props
  const schemaData = {}

  // [NGE1-5207] The card name is editable when editing a saved card too, so
  // it gets the same (market-based) validation as adding a card. The field
  // is not prefilled in edit mode, so it stays optional there (an empty name
  // behaves as before); a typed name must be valid.
  Object.assign(
    schemaData,
    getCardNameSchema({
      inputName: 'cardFirstName',
      isRequired: !isFromEditPayment,
    })
  )
  Object.assign(schemaData, getExpiryDate())
  getPaymentContainer().tokenExSavePaymentTypeValid =
    isFromCheckout && hasSubscriptionProduct

  if (
    customerContainer.isRegisterUser &&
    ((isFromCheckout && hasSubscriptionProduct) ||
      isFromEditSubscription ||
      isFromPayment)
  ) {
    Object.assign(
      schemaData,
      getRequiredCheckboxSchema({
        inputName: 'addPaymentToProfile',
        requiredErrorText:
          isFromPayment || isFromCheckout
            ? savePaymentToProfileErrorMsg
            : addPaymentToProfileErrorMsg,
      })
    )
  }
  if (shouldRenderAddressForm) {
    Object.assign(
      schemaData,
      getRequiredSchema({
        inputName: 'country',
        requiredType: 'country',
      })
    )
  }

  return yup.object(schemaData)
}
